import {Injectable} from '@angular/core';
import {Http, Headers, RequestOptions, Response} from '@angular/http';

import {Archive} from './archive';

@Injectable()
export class ArchiveService {

    constructor(private http: Http) {

    }

    getAll(page: number = 1, sort: string = '') {
        let currentfilter = JSON.parse(localStorage.getItem('filter'));
        if (!currentfilter) {
            currentfilter = {};
        }

        const params = new URLSearchParams();
        params.set('page', page + '');
        params.set('sorts', sort);
        for (let key in currentfilter) {
            if (currentfilter[key]) {
                params.set('filter[' + key + ']', currentfilter[key])
            }
        }
        return this.http.get('archive?' + params.toString()).map((response: Response) => response.json());
    }
    getAllArchive() {
        return this.http.get('archive/all').map((response: Response) => response.json());
    }

    getById(_id: string) {
        return this.http.get('archive/' + _id).map((response: Response) => response.json());
    }

    getParents(_id: string) {
        return this.http.get('archive/parents/' + _id).map((response: Response) => response.json());
    }

    getTrashedById(_id: string) {
        return this.http.get('archive/trashed/' + _id).map((response: Response) => response.json());
    }

    restoreTrashedById(_id: string) {
        return this.http.put('archive/trashed/' + _id, {}).map((response: Response) => response.json());
    }

    create(archive: Archive) {
        return this.http.post('archive', archive).map((response: Response) => response.json());
    }

    update(archive: Archive) {
        return this.http.put('archive/' + archive.id, archive).map((response: Response) => response.json());
    }

    delete(_id: string) {
        return this.http.delete('archive/' + _id).map((response: Response) => response.json());
    }
}



// WEBPACK FOOTER //
// ./src/app/views/setting/archive/archive.service.ts